module.exports = __webpack_public_path__ + "2bcb98bc1f85598f0cafbfdad9be264f.png";